import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SeveritySelected } from 'src/app/helpers';
import { LocaleService } from 'src/app/services/locale/locale.service';
import { RatingService } from 'src/app/services/rating/rating.service';
import { SharedService } from 'src/app/services/shared/shared.service';

@Component({
  selector: 'app-repair-cost',
  templateUrl: './repair-cost.component.html',
  styleUrls: ['./repair-cost.component.scss'],
})
export class RepairCostComponent implements OnInit {
  public selectedSeverity: SeveritySelected = {
    exterior: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null,
      },
      endCorrection: {},
    },
    interior: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null,
      },
      endCorrection: {},
    },
    mechanics: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null,
      },
      endCorrection: {},
    },
    frame: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null,
      },
      endCorrection: {},
    },
    major_options: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null,
      },
      endCorrection: {},
    },
  };
  public exteriorLabourCost: string | number = null;
  public interiorLabourCost: string | number = null;
  public mechanicsLabourCost: string | number = null;
  public frameLabourCost: string | number = null;
  public majorOptionsLabourCost: string | number = null;

  public exteriorPartCost: string | number = null;
  public interiorPartCost: string | number = null;
  public mechanicsPartCost: string | number = null;
  public framePartCost: string | number = null;
  public majorOptionsPartCost: string | number = null;

  public exteriorCost: string | number = null;
  public interiorCost: string | number = null;
  public mechanicsCost: string | number = null;
  public frameCost: string | number = null;
  public majorOptionsCost: string | number = null;
  public totalRepairCost: string | number = null;

  public subscriptions: Subscription[] = [];

  constructor(
    public sharedService: SharedService,
    public ratingService: RatingService,
    public localeServive: LocaleService
  ) {}

  ngOnInit(): void {
    this.getState();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  // Getting state data
  getState() {
    let data: object = { vehicle_id: this.sharedService.getVehicleId };

    const stateSub = this.ratingService.getRatingStates(data).subscribe(
      (res) => {
        if (res) {
          let success: boolean = res['success'];
          let data: object = res['data'];

          if (success && Object.keys(data).length) {
            const states: SeveritySelected = data['ratingStates']
              ? JSON.parse(data['ratingStates']['rating_states'])
              : null;

            if (states) {
              this.selectedSeverity = states;
              this.exteriorLabourCost =
                +states['exterior']['overall']['labour_cost'] ?? 0;
              this.interiorLabourCost =
                +states['interior']['overall']['labour_cost'] ?? 0;
              this.mechanicsLabourCost =
                +states['mechanics']['overall']['labour_cost'] ?? 0;
              this.frameLabourCost =
                +states['frame']['overall']['labour_cost'] ?? 0;
              this.majorOptionsLabourCost =
                +states['major_options']['overall']['labour_cost'] ?? 0;

              this.exteriorPartCost =
                +states['exterior']['overall']['part_cost'] ?? 0;
              this.interiorPartCost =
                +states['interior']['overall']['part_cost'] ?? 0;
              this.mechanicsPartCost =
                +states['mechanics']['overall']['part_cost'] ?? 0;
              this.framePartCost =
                +states['frame']['overall']['part_cost'] ?? 0;
              this.majorOptionsPartCost =
                +states['major_options']['overall']['part_cost'] ?? 0;

              this.exteriorCost =
                +states['exterior']['overall']['repair_cost'] ?? 0;
              this.interiorCost =
                +states['interior']['overall']['repair_cost'] ?? 0;
              this.frameCost = +states['frame']['overall']['repair_cost'] ?? 0;
              this.mechanicsCost =
                +states['mechanics']['overall']['repair_cost'] ?? 0;
              this.majorOptionsCost =
                +states['major_options']['overall']['repair_cost'] ?? 0;
            }

            this.totalRepairCost =
              (states
                ? +states['exterior']['overall']['repair_cost'] ?? 0
                : 0) +
              (states
                ? +states['interior']['overall']['repair_cost'] ?? 0
                : 0) +
              (states ? +states['frame']['overall']['repair_cost'] ?? 0 : 0) +
              (states
                ? +states['mechanics']['overall']['repair_cost'] ?? 0
                : 0) +
              (states
                ? +states['major_options']['overall']['repair_cost'] ?? 0
                : 0);
          }
            }
      },
      (error: HttpErrorResponse) => {}
    );

    this.subscriptions.push(stateSub);
  }
}
